import reduceReducers from 'reduce-reducers';

const toCamelCase = (str) =>
  str.replace(/_([a-z])/g, (s) => s[1].toUpperCase());

// Load all action handlers
const req = require.context('.', false, /^\.\/(?!index).*\.js$/);
const actionHandlers = req.keys().map((file) => req(file).default);

// Setup default state from the action handlers
const defaultState = actionHandlers.reduce(
  (state, actionHandler) => Object.assign(state, actionHandler.defaultState),
  {}
);

// Add convenient action creators for use in the app
actionHandlers.forEach((actionHandler) => {
  module.exports[toCamelCase(actionHandler.name)] = actionHandler.actionCreator;
});

// Combine action reducers
export const reducers = reduceReducers(
  (state = defaultState) => state,
  ...actionHandlers.map(({ reducers }) => reducers)
);
